import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="page fade-up min-h-[70vh] flex items-center justify-center">
      <div data-testid="payment-cancel" className="max-w-md w-full text-center py-10">
        <XCircle className="mx-auto text-zinc-400 mb-4" size={56} />
        <div className="font-display font-extrabold text-2xl mb-2">Pagamento cancelado</div>
        <p className="text-sm text-zinc-600 mb-6">
          Não foi cobrado nada. Podes tentar novamente a qualquer momento a partir do teu anúncio.
        </p>
        <Link to="/perfil" data-testid="cancel-back-btn"
          className="inline-block px-6 py-3 rounded-xl bg-black text-white font-semibold hover:bg-[#c8102e] transition-colors">
          Voltar ao perfil
        </Link>
      </div>
    </div>
  );
}
